import { useMe } from '@hooks/getQueries';
import { Navigate } from 'react-router-dom';
import useSession from '../hooks/useSession';

const OnboardingRoute = ({ children }) => {
  const { isAuthenticated, loading: authLoading } = useSession();
  const { data: me, isPending: meLoading } = useMe(isAuthenticated);

  // Show loading state while checking authentication or fetching user data
  if (authLoading || (isAuthenticated && meLoading)) {
    return <></>;
  }

  // Redirect to signin if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/signin" replace />;
  }

  if (me?.mfa_setup_required) {
    return <Navigate to="/mfa-setup" replace />;
  }

  if (me?.is_onboarding && !meLoading) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};

export default OnboardingRoute;
